import { axios, ICalendarUrl, IDataConnectCalendars, Store, } from "@utils";
import { AxiosResponse } from "axios";
import { action, makeObservable, runInAction } from "mobx";
import { Service } from "typedi";

@Service()
export class PrivateCalendarsStore extends Store<ICalendarUrl> {

  constructor() {
    super();
    makeObservable(this);
  }

  innerCalendar: ICalendarUrl = {
    id: -1,
    calendarColor: 'INNER_CALENDAR_COLOR',
    calendarType: 'WORK',
    calendarUri: '',
    title: 'РЕЛЭКС.Календарь'
  };

  @action getConnectingUrls() {
    this.isLoading = true;
    return axios
      .get('integration/ical')
      .then((resp: AxiosResponse<IDataConnectCalendars>) => runInAction(() => {
        this.data = resp.data.linkedCalendars;
        this.isLoading = false;
      }));
  }
}
